import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Warning } from "@phosphor-icons/react";
import api from "../api";

// v414.25 — SHORTFALL DASHBOARD (owner-facing, Store Orders page).
// Running list of order lines where the distributor's own stock couldn't
// cover the sale: who covered it (parent / master via v414.24 fallback) and
// what's still short — the under-stocked-distributor radar.
export const ShortfallCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/store-orders/shortfalls").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data || data.rows.length === 0) return null;

  return (
    <div className="bg-white border border-amber-300 rounded-xl p-4 space-y-3" data-testid="shortfall-card">
      <div>
        <h2 className="text-sm font-semibold flex items-center gap-2">
          <Warning size={16} weight="bold" className="text-amber-600" />
          {t("store_orders.shortfalls_title")}
          <span className="text-xs font-normal text-zinc-400">({data.rows.length})</span>
        </h2>
        <p className="text-[11px] text-zinc-500 mt-0.5">{t("store_orders.shortfalls_sub")}</p>
      </div>

      {data.summary.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="shortfall-summary">
          {data.summary.slice(0, 6).map((s) => (
            <span key={s.distributor_id}
              className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-[11px] font-semibold text-amber-800">
              {s.distributor_name}
              <span className="font-normal text-amber-600">
                {t("store_orders.shortfalls_tally", { pulled: s.pulled_units, short: s.short_units })}
              </span>
            </span>
          ))}
        </div>
      )}

      <div className="max-h-64 overflow-y-auto divide-y divide-zinc-100" data-testid="shortfall-rows">
        {data.rows.map((r, i) => (
          <div key={`${r.reference}-${r.item_name}-${i}`} className="py-2 text-[12px] flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
            <span className="font-mono text-[10px] text-zinc-400">{(r.created_at || "").slice(0, 10)}</span>
            <span className="font-semibold text-zinc-900">{r.distributor_name}</span>
            <span className="text-zinc-600">{r.item_name} ×{r.quantity}</span>
            {(r.pulls || []).map((p, j) => (
              <span key={j} className="text-emerald-700 font-medium">
                {t("store_orders.pulled_from", { n: p.taken, name: p.owner_name })}
              </span>
            ))}
            {r.still_short > 0 && (
              <span className="text-red-600 font-semibold">
                {t("store_orders.still_short", { n: r.still_short })}
              </span>
            )}
            <span className="font-mono text-[10px] text-zinc-400 ml-auto">{r.reference}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
